<template>
  <div v-if="checkMemberId">
    <b-row class="component-margin">
      <b-col class="zoom-back-1" sm="2">
        <date-picker id="startDate" :value="startDate" @change="updateStartDate($event)"/>
      </b-col>
      <b-col class="zoom-back-1" sm="2">
        <date-picker id="endDate" :value="endDate" @change="updateEndDate($event)"/>
      </b-col>
      <!-- <b-col sm="1">
        <b-form-input size="sm" v-model="forcastRatio" type="text"/>
      </b-col> -->
      <b-col sm="3">
        <b-btn size="sm" @click="outputCsv(null)" variant="danger">ファイル出力</b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="zoob-back-0">
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                :items="filteredItems" :fields="fields"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="date" slot-scope="row">
            <label>{{formatDate(row.value)}}</label>
          </template>
          <template slot="salesDoller" slot-scope="row">
            <label>{{formatPriceDoller(row.value)}}</label>
          </template>
          <template slot="salesYen" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="purchaseAmountYen" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="shippingCostYen" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="stockAmount" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="cacheFlowProfit" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="forcastTargetSales" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="forcastTargetProfit" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <!-- <template slot="operation" slot-scope="row">
            <b-button size="sm" @click="editModal(row)" variant="warning">操作</b-button>
          </template> -->
        </b-table>
        <!-- <div md="6" v-if="(editable && memberId !== '') || !editable">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
        </div> -->
      </b-col>
    </b-row>
    <b-modal ref="editModal" title="Submit Your Name" @ok="handleOk">
      <b-form-group size="sm" horizontal label="売上-$" label-class="text-sm-right" label-for="salesDoller">
        <b-form-input size="sm" id="salesDoller" v-model="editItem.salesDoller" type="text"/>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import SellerSelectModal from '@/components/common/SellerSelectModal';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    editable: {
      default: false,
    },
    imember: {
      default: '',
    },
    version: {
      default: 0,
    },
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'date'                       , label: '日付', sortable: true, variant: 'base' },
        { key: 'salesDoller'                , label: '売上-$', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'exchange'                   , label: '為替', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'salesYen'                   , label: '売上-円', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'purchaseAmountYen'          , label: '購入-円', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'shippingCostYen'            , label: '送料-円', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'stockAmount'                , label: '在庫金額', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'cacheFlowProfit'            , label: 'CF利益', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'cacheFlowProfitRate'        , label: 'CF利益率', sortable: true, variant: 'success', class: 'table-right' },
        { key: 'stockEfficiency'            , label: '在庫効率', sortable: true, variant: 'success', class: 'table-right' },
        { key: 'forcastTargetSales'         , label: 'T売上', sortable: true, variant: 'base', class: 'table-right' },
        { key: 'forcastTargetProfit'        , label: 'T利益', sortable: true, variant: 'base', class: 'table-right' }
        // { key: 'operation'                  , label: '操作', sortable: false, class: 'table-cw4' }
      ],
      totalRows: 0,
      sortBy: 'date',
      sortDesc: true,
      sortDirection: 'desc',
      filter: '',
      editItem: {},
      confirmMessage: '',
      startDate: '',
      endDate: '',
      forcastRatio: '',
      memberId: '',
    };
  },
  computed: {
    filteredItems() {
      let filteredItems = this.items.filter(item => {
        return (item.date >= this.startDate && item.date <= this.endDate);
        });
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      return filteredItems;
    },
    checkMemberId() {
      // SLC担当の場合
      if(this.editable && this.imember !== '' && this.version !== 0){
        this.memberId = this.imember;
        this.callApi();
        return true;
      }
      // 会員の場合
      if(!this.editable && this.version !== 0){
        this.memberId = this.$store.state.account;
        this.callApi();
        return true;
      }
      return false;
    },
  },
  created() {
    var dtEnd = new Date();
    var dtStart = new Date();
    dtStart.setDate(dtStart.getDate()-30);

    var y = dtStart.getFullYear();
    var m = ('00' + (dtStart.getMonth()+1)).slice(-2);
    var d = ('00' + dtStart.getDate()).slice(-2);
    if(this.startDate === '') {
      this.startDate = y + m + d;
    }

    var y = dtEnd.getFullYear();
    var m = ('00' + (dtEnd.getMonth()+1)).slice(-2);
    var d = ('00' + dtEnd.getDate()).slice(-2);
    if(this.endDate === '') {
      this.endDate = y + m + d;
    }

    // if (this.editable === false) {
    //   this.memberId = this.$store.state.account;
    //   api.getAnalysisSales(this.memberId, 'total',this.startDate, this.endDate, (items) => {
    //     this.items = items;
    //     this.totalRows = this.items.length;
    //   });
    // }
  },
  methods: {
    updateStartDate($event) {
      this.startDate = $event;
      // this.callApi();
    },
    updateEndDate($event) {
      this.endDate = $event;
      // this.callApi();
    },
    callApi() {
      api.getAnalysisSales(this.memberId, 'total',this.startDate, this.endDate, (items) => {
        this.items = items;
        this.totalRows = this.items.length;
      });
    },
    editModal(row) {
      this.editItem = {};
      this.isUpdate = false;
      if (row !== null) {
        this.isUpdate = true;
        // Object.assign(this.editItem , row.item);
        this.editItem =  Object.assign({}, this.editItem , row.item);
      }
      this.$refs.editModal.show();
    },
    handleOk() {
       if (this.isUpdate) {
        api.updateAnalysisSales(this.memberId, this.editItem, 'total', (items) => {
           this.items = items;
           this.totalRows = this.items.length;
         });
       }
    },
    outputCsv() {
      let csv = '\ufeff' + '日付,売上-$,為替,売上-円,購入-円,送料-円,在庫金額,CF利益,CF利益率,在庫効率,T売上,T利益\n';
      let ids = [ 'date', 'salesDoller', 'exchange', 'salesYen', 'purchaseAmountYen', 'shippingCostYen', 'stockAmount', 'cacheFlowProfit', 'cacheFlowProfitRate', 'stockEfficiency', 'forcastTargetSales', 'forcastTargetProfit' ];
      let fileName = '';
      for (const item of this.items) {
        for (const id of ids) {
          csv += item[id] + ',';
        }
        csv += '\n';
      }
      fileName = '売上分析(累積).csv';
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
  },
};

Vue.component('seller-select-modal', SellerSelectModal);
</script>

<style>
.component-margin {
  margin-bottom: 1rem;
}

.zoom-back-0{
  z-index: 0;
}
.zoom-back-1{
  z-index: 1;
}

@media (min-width: 768px) {
  .table-right  { text-align:right!important; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center!important; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center!important; }
  .table-lw15 { max-width: 15rem; word-wrap: break-word;          text-align:left!important;   }
  .table-lw6  { max-width: 6rem; }
}
</style>
